import { Row } from 'antd';
import styled from 'styled-components';

export const FormWrapper = styled.div`
    padding: 10px 0 0px;
`;

export const RadioFormItemRowWrapper = styled(Row)`
    align-items: end;
    .ant-col {
        padding: 0px;
    }
    .ant-form-item-label > label,
    .ant-radio-wrapper {
        font-size: var(--font-size-md);
    }
`;

export const AdminApplicationActiveSwitchWrapper = styled.div`
    .ant-switch {
        margin-top: 12px;
        margin-left: 10px;
    }
`;
